module.exports = __webpack_public_path__ + "img/question-1.05f56098.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svetlana/question-1.png
// module id = Y7HQ
// module chunks = 1